import { Eye, Printer } from 'react-feather';
import PageLayout from '../../../components/PageLayout';
import {
  formatDate,
  getItemById,
  getQueryString,
  limitOptions,
} from '../../../utils/common.util';
import useSWR from 'swr';
import { useState } from 'react';
import PaymentsReportsModal from './PaymentsReportsModal';
import {
  DatePicker,
  DatePickerInput,
  Pagination,
} from 'carbon-components-react';
import PrintOutHead from '../../../components/PrintOutHead';
import { PrintView } from '../../../components/PrintView/print-view.component';
import CustomButton from '../../../components/custom-button/custom-btn.component';
import { useUrlState } from '../../../utils/useUrlState';
import Combobox from '../../../components/combobox/Combobox';
import { useDebounceState } from '../../../utils/useDebounceState';

const initialData = {
  date: '',
  schoolId: '',
  skip: 0,
  take: 10,
};

export default function SubscriptionReport() {
  const [isOpen, setIsOpen] = useState('');
  const [query, setQuery] = useUrlState(initialData);

  const [searchSchool, setSearchSchool] = useDebounceState('');
  const { data: schools, isLoading: isLoadingSchools } = useSWR(
    `school/list/v2?${getQueryString({
      query: searchSchool,
      schoolType: 'REGULAR',
    })}`,
  );

  const { data, isLoading, error } = useSWR(
    `school/subscription/report?${getQueryString(query)}`,
  );

  const entries = data?.response ?? [];
  // const totals = data?.totals ?? {};

  return (
    <PageLayout
      breadcrumbs={[
        { label: 'Admin', to: '/admin' },
        { label: `Subscription Report`, active: true },
      ]}
      title={
        <div
          className="d-flex align-items-center flex-wrap"
          style={{ gap: '30px' }}
        >
          <h1 className="h-20">Subscription Report</h1>{' '}
          <button
            className="text-12 text-primary d-flex align-items-center font-bold pointer clean-btn "
            style={{ gap: '4px' }}
            onClick={() => setIsOpen('reports')}
          >
            <Eye size="14" strokeWidth="2px" />
            <span>VIEW OTHER REPORTS</span>
          </button>
        </div>
      }
      isLoading={isLoading}
    >
      {/* FILTERS  */}
      {/* <p className="mt-20 text-12">
        Select at least a start and end dates to show report.
      </p> */}
      <div className="mt-10 card-row-2">
        <Combobox
          options={schools ?? []}
          label="School"
          value={
            query.schoolId
              ? schools?.find((s) => s.id === Number(query.schoolId))
              : null
          }
          onChange={(option) => {
            setQuery({ schoolId: option ? option.id : '' });
            setSearchSchool('');
          }}
          onSearch={setSearchSchool} // The combobox now just updates the search term state
          onClear={() => {
            setQuery({ schoolId: '' });
            setSearchSchool('');
          }}
          loading={isLoadingSchools} // Pass the loading state down
          renderSelected={(option) => `${option.name}`}
          renderOption={(option) => `${option.name}`}
          labelKey="fullName"
          valueKey="id"
          searchPlaceholder="Search schools..."
          placeholder=""
        />
        <DatePicker
          dateFormat="Y-m-d"
          datePickerType="single"
          id="end-date-picker"
          // minDate={
          //   new Date(query.dateFrom ?? '').toISOString().split('T')[0]
          // }
          maxDate={new Date().toISOString().split('T')[0]}
          onChange={(value) => {
            if (value.length > 0) {
              setQuery({
                date: [
                  value[0].getFullYear(),
                  ('0' + (value[0].getMonth() + 1)).slice(-2),
                  ('0' + value[0].getDate()).slice(-2),
                ].join('-'),
              });
            } else setQuery({ date: '' });
          }}
          onClose={(value) => {}}
        >
          <DatePickerInput
            className="end-date"
            id="end-date"
            name="dateTo"
            labelText="As Of"
            value={query.date}
            max={new Date().toISOString().split('T')[0]}
            // pattern="d{1,2}/d{4}"
            pattern="\d{4}-\d{2}-\d{2}"
            autoComplete="off"
            placeholder="YYYY-MM-DD"
            type="text"
            onChange={(e) => setQuery({ date: e.target.value })}
          />
        </DatePicker>
      </div>

      <div className="mt-20">
        {error && <p className="text-14 mt-10 text-danger">{error.message}</p>}
        {entries?.length > 0 && (
          <>
            <PrintOutHead
              title={`Subscription Report`}
              headings={[
                {
                  label: 'School',
                  value: getItemById(schools, query.schoolId)?.name ?? 'All',
                },
                {
                  label: 'Date',
                  value: `${formatDate(query.date)}`,
                },
              ]}
            />
            <PrintView>
              <div style={{ overflow: 'auto' }}>
                <table className="bx--data-table table-white">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>School</th>
                      <th>Last Change (GH₵)</th>
                      <th>Current (GH₵)</th>
                      <th>Current Changed Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {entries.map((entry) => {
                      return (
                        <tr key={entry.id}>
                          <td>{entry.epobsAccountId}</td>
                          <td>{entry.epobsAccountName}</td>
                          <td>{entry.previousSubscriptionAmount}</td>
                          <td>{entry.currentSubscriptionAmount}</td>
                          <td>{formatDate(entry.createdAt)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </PrintView>
            <Pagination
              backwardText="Previous page"
              forwardText="Next page"
              page={Number(query.skip) + 1}
              pageNumberText="Page Number"
              pageSize={Number(query.take)}
              pageSizes={limitOptions(data?.paginationInfo?.totalCount)}
              totalItems={data?.paginationInfo?.totalCount}
              onChange={(value) =>
                setQuery({ skip: value.page - 1, take: value.pageSize })
              }
            />
          </>
        )}
        {entries?.length === 0 && (
          <p className="text-14 mt-30 text-grey">No data available.</p>
        )}

        {entries?.length > 0 && (
          <div
            className="mt-30"
            style={{
              display: 'flex',
              justifySelf: 'end',
              gap: '20px',
              alignItems: 'center',
            }}
          >
            <CustomButton classes="secondary" onClick={() => window.print()}>
              <Printer size="16" strokeWidth="2px" /> &nbsp; Print
            </CustomButton>
          </div>
        )}
      </div>

      <PaymentsReportsModal
        isOpen={isOpen === 'reports'}
        closeModal={() => setIsOpen('')}
      />
    </PageLayout>
  );
}
